module.exports = __webpack_public_path__ + "marker.svg?ea657d5cb9bc615ba03f46874674e3e4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marker.svg
// module id = 977
// module chunks = 2